// extracted by mini-css-extract-plugin
export default {"affirmative":"Affirmative-module__affirmative--wkJaj","copilotRun":"Affirmative-module__copilotRun--kyiZX"};